<script setup lang="ts">
import StatusBadge from "./StatusBadge.vue"

defineProps<{
  subtitle?: string
  status?: string
  title: string
}>()
</script>

<template>
  <aside class="dashboard-card dashboard-card--static h-fit">
    <div class="p-5">
      <div class="mb-5 flex items-start justify-between gap-3">
        <div class="min-w-0">
          <h2 class="dashboard-mono truncate text-sm font-medium text-(--dash-ink)">
            {{ title }}
          </h2>
          <p v-if="subtitle" class="mt-1 truncate text-sm text-(--dash-muted)">{{ subtitle }}</p>
        </div>
        <StatusBadge v-if="status" :status="status" />
      </div>
      <slot />
      <footer v-if="$slots.footer" class="mt-5 border-t border-(--dash-line) pt-4">
        <slot name="footer" />
      </footer>
    </div>
  </aside>
</template>
